import React, { useState, useEffect } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input, Col, Row } from 'reactstrap';
import axios from 'axios'

// Import API config object
import { tokenConfig } from '../../utils/apiConfig'

const AddSessions = (props) => {
    const [date, setDate] = useState('')
    const [starttime, setStarttime] = useState('')
    const [endtime, setEndtime] = useState('')
    const [registrations, setRegistrations] = useState('')
    const [status, setStatus] = useState('')

    const {
        addToSessionList,
        updateSessionList,
        eventSession,
        sessionModal,
        toggle,
        eventId,
    } = props

    const isNew = !eventSession

    useEffect(() => {
        resetForm()
        if (eventSession) {
            setDate(eventSession.date && eventSession.date.substr(0, 10))
            setStarttime(eventSession.starttime)
            setEndtime(eventSession.endtime)
            setStatus(eventSession.status)
            setRegistrations(eventSession.registrations)
        }
    }, [eventSession])

    const resetForm = () => {
        setDate('')
        setStarttime('')
        setEndtime('')
        setStatus('')
        setRegistrations('')
    }

    const updateEvent = async e => {
        e.preventDefault()
        const sessionDetails = {
            eventId, date, starttime, endtime, status, company_id: "5f44f153841c2929c2eee625"
        }

        if (isNew) {
            await axios.post('/api/event-sessions', sessionDetails, tokenConfig())
                .then(res => {
                    toggle(false)
                    addToSessionList(res.data)
                    resetForm()
                })
                .catch(err => console.log(err.message))
        } else {
            await axios.patch('/api/event-sessions', { _id: eventSession._id, registrations, ...sessionDetails }, tokenConfig())
                .then(res => {
                    toggle(false)
                    updateSessionList(res.data)
                    resetForm()
                })
                .catch(err => console.log(err.message))
        }

    }

    return (
        <Modal isOpen={sessionModal} size='lg' toggle={() => toggle(false)}>
            <ModalHeader toggle={() => toggle(false)}>Update Event</ModalHeader>
            <Form onSubmit={updateEvent}>
                <ModalBody>
                    <Row>
                        <Col>
                            <FormGroup>
                                <Label>Date</Label>
                                <Input type="date" defaultValue={date} onChange={e => setDate(e.target.value)} required />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <FormGroup>
                                <Label>Start Time</Label>
                                <Input type="time" defaultValue={starttime} onChange={e => setStarttime(e.target.value)} required />
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <Label>End Time</Label>
                                <Input type="time" defaultValue={endtime} onChange={e => setEndtime(e.target.value)} required />
                            </FormGroup>
                        </Col>
                    </Row>
                    {!isNew && <Row>
                        <Col>
                            <FormGroup>
                                <Label>Registrations</Label>
                                <Input type="number"
                                    defaultValue={registrations}
                                    onChange={e => setRegistrations(e.target.value)}
                                    required
                                />
                            </FormGroup>
                        </Col>
                    </Row>}
                    <Row>
                        <Col>
                            <FormGroup>
                                <Label>Status</Label>
                                <Input type="select" defaultValue={status} onChange={e => setStatus(e.target.value)} required>
                                    <option></option>
                                    <option>Open</option>
                                    <option>Closed</option>
                                </Input>
                            </FormGroup>
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button type='submit' color="primary">{isNew ? 'Add' : 'Update'}</Button>{' '}
                    <Button color="secondary" onClick={() => toggle(false)}>Cancel</Button>
                </ModalFooter>
            </Form>
        </Modal>
    );
}

export default AddSessions;